<script setup lang="ts">
import { ref } from 'vue';
import Bugsnag from '@bugsnag/js';

import Header from './ui/Header.vue';
import Navigation from './ui/Navigation/index.vue';

import useAgent from '@/providers/useAgent';

const visible = ref<boolean>(false);
const onClose = () => {
  visible.value = false;
};
const onShow = () => {
  visible.value = true;
};

const agent = useAgent();
Bugsnag.addOnError((event) => {
  if (agent) {
    event.addMetadata('agent', {
      id: agent.agent.value.id,
      email: agent.agent.value.email,
      permissions: agent.agent.value.permissions,
    });
  }
});
</script>
<template>
  <div class="flex min-h-screen min-w-0 dark:bg-gray-900">
    <Navigation
      class="hidden md:block shadow-sm border-r border-gray-100 dark:border-gray-700"
      :visible="visible"
      :on-close="onClose"
    />
    <div class="flex min-w-0 flex-1">
      <div class="flex min-w-0 flex-1 flex-col">
        <Header
          class="shadow-sm relative z-10 border-b border-gray-100 dark:border-gray-700"
          :on-show="onShow"
          :visible="visible"
        />
        <div class="flex min-w-0 flex-1 flex-col">
          <slot />
        </div>
      </div>
      <slot name="sidebar" />
    </div>
  </div>
</template>
